import { Logo as SeekLogo } from '@seek/logo';
import { Box } from 'braid-design-system';
import React from 'react';




const WithLink = ({
  children,
}: {
  children: React.ReactNode;
  isMobileClient?: boolean;
}) => {


  return (
    <>{children}</>
  );
};


const Logo = () => {

  // standard is larger in this case
  const size ='standard';

  // so we can test using label instead + better for screen readers

  const label = 'SEEK';

  return (
    <WithLink >
      <Box aria-label={label}>
          <SeekLogo size={size} brand='seek' />;
      </Box>
    </WithLink>
  );
};

export default Logo;
